import { stationMunicipalitiesTypes } from "./stationMunicipalitiesTypes";

const {
  GET_STATION_MUNICIPALITIES_STATES,
  SET_STATION_MUNICIPALITIES_FILTERS,
  GET_STATION_MUNICIPALITIES,
  CREATE_STATION_MUNICIPALITIES,
  DELETE_STATION_MUNICIPALITIES,
  CLEAR_STATION_MUNICIPALITIES,
  SET_CONFIG_FILTER_STATION_MUNICIPALITIES,
  SET_CONFIG_PAGE_STATION_MUNICIPALITIES,
  SET_CONFIG_PAGE_SIZE_STATION_MUNICIPALITIES,
  SET_CONFIG_SORTED_STATION_MUNICIPALITIES,
} = stationMunicipalitiesTypes

const INITIAL_STATE = {
  stationMunSelected: null,
  stationMunArr: [],
  stationMunStatesArr: [],
  munStatesNotAvailable: new Set(),
  station: {},
  config: {
      page: 0,
      pageSize: 20,
      filtered: [],
      sorted: []
  },
}

export const stationMunicipalitiesReducer = (state = INITIAL_STATE, {type, payload}) => {

  switch (type) {
    
    case SET_STATION_MUNICIPALITIES_FILTERS:
      return {
          ...state,
          [payload.key]: payload.data,
      };

    case GET_STATION_MUNICIPALITIES_STATES:
      return {
        ...state,
        stationMunStatesArr: payload,
      }

    case GET_STATION_MUNICIPALITIES: {
      const stationMun = payload || []
      const newMunStatesNotAvailable = new Set()
      stationMun.forEach(mun => { if(mun?.id) newMunStatesNotAvailable.add(mun?.id) })
      return {
        ...state,
        stationMunArr: payload,
        munStatesNotAvailable: newMunStatesNotAvailable
      }
    }

    case CREATE_STATION_MUNICIPALITIES:
      return {
        ...state,
        stationMunArr: [payload, ...state.stationMunArr],
        munStatesNotAvailable: new Set(state.munStatesNotAvailable).add(payload?.idMunicipality)
      }

    case DELETE_STATION_MUNICIPALITIES:
      return {
        ...state,
        stationMunArr: state.stationMunArr.filter(stationMun => 
          !(stationMun.idStation === payload.idStation 
          && stationMun.id === payload.id))
      }

    case CLEAR_STATION_MUNICIPALITIES:
      return {
          ...state,
          ...INITIAL_STATE,
      };

    case SET_CONFIG_FILTER_STATION_MUNICIPALITIES:
      return {
          ...state,
          config: {
              ...state.config,
              filtered: payload,
              page: 0,
          },
      };

    case SET_CONFIG_PAGE_STATION_MUNICIPALITIES:
        return {
            ...state,
            config: {
                ...state.config,
                page: payload,
            },
        };

    case SET_CONFIG_PAGE_SIZE_STATION_MUNICIPALITIES:
        return {
            ...state,
            config: {
                ...state.config,
                pageSize: payload,
                page: 0,
            },
        };

    case SET_CONFIG_SORTED_STATION_MUNICIPALITIES:
        return {
            ...state,
            config: {
                ...state.config,
                sorted: payload,
                page: 0,
            }
        }
  
    default :
      return state
  }
}